const devConfig = {
  baseUrl: 'https://localhost:5001'
};

const prodConfig = {
  baseUrl: 'https://scottrupprecht.azurewebsites.net'
};

export default process.env.NODE_ENV === 'production' ? prodConfig : devConfig;
